export default [
    {
        id: 1,
        name_ca: 'Desconeguda',
        name_es: 'Desconocida',
        name_en: 'Unknown'
    }, {
        id: 2,
        name_ca: 'Superficial',
        name_es: 'Superficial',
        name_en: 'Shallow'
    }, {
        id: 3,
        name_ca: 'Formigó ciclopi',
        name_es: 'Hormigón ciclópeo',
        name_en: 'Cyclopean'
    }, {
        id: 4,
        name_ca: 'Formigó armat',
        name_es: 'Hormigón armado',
        name_en: 'Reinforced concrete'
    }, {
        id: 5,
        name_ca: 'Correguda',
        name_es: 'Corrida',
        name_en: 'Linear'
    }, {
        id: 6,
        name_ca: 'Sabates',
        name_es: 'Zapatas',
        name_en: 'Footings'
    }, {
        id: 7,
        name_ca: 'Flotant',
        name_es: 'Flotante',
        name_en: 'Floating'
    }, {
        id: 8,
        name_ca: 'Profunda',
        name_es: 'Profunda',
        name_en: 'Deep'
    }, {
        id: 9,
        name_ca: 'Pilotis',
        name_es: 'Pilotis',
        name_en: 'Pile foundation'
    }
]





// WEBPACK FOOTER //
// ./src/options/foundations.js